export const VOD_PATHS = {
	PLAYER: '/vod/ogladaj/:type/:id',
	SECTION_DETAILS: '/vod/sekcja/:sectionId/:sectionName',
	CATEGORIES: '/vod/kategorie',
	DETAILS: '/vod/:type/:id/:title',
	VODS: '/vod/filmy',
	KIDS: '/vod/dla-dzieci',
	TRANSACTION: '/vod/transakcja/:transactionType/:type/:id'
};
